<template>
  <b-container fluid style="margin-top:90px;">
    <b-card v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card>

    <b-card v-if="!loading">
      <b-table striped outlined hover :items="classes" :fields="fields">
        <template #cell(editkey)="data">
          <ClassEditBtn :ClassId="data.item.ID" :token="token" />
        </template>

        <template #cell(deletekey)="data">
          <ClassDeleteBtn v-on:removeClass="removeClass" :ClassID="data.item.ID" :token="token" />
        </template>
      </b-table>
    </b-card>

    <b-card class="mt-1" v-if="!loading">
      <b-form @submit="onSubmit">
        <b-form-group id="input-group-1" :label="$t('NEW_CLASS')" label-for="input-1">
          <b-form-input v-model="form.Name" type="text" required :placeholder="$t('ENT_CLASS_NAME')"></b-form-input>
        </b-form-group>

        <div class="d-flex align-items-center">
          <b-button type="submit" variant="primary">{{$t("CREATE")}}</b-button>
        </div>
      </b-form>
    </b-card>
  </b-container>
</template>
<script>
import { ajaxGet, ajaxPost } from "../../ajax";
import ClassDeleteBtn from "./ClassDeleteBtn";
import ClassEditBtn from "./ClassEditBtn";
import {apiUrl} from "@/main";

export default {
  components: {
    ClassDeleteBtn,
    ClassEditBtn
  },
  mounted: function() {
    this.loading = true;

    var classesPanelComp = this;

    setTimeout(function() {
      ajaxGet(
        apiUrl() + "/classes",
        classesPanelComp.dataSuccessLoad,
        classesPanelComp.dataError,
        classesPanelComp.token
      );
    }, 50);

    //window.alert(this.token);
  },
  data: function() {
    return {
      classes: [],
      fields: [
        {key: "ID", label: this.$t("ID"),thClass: 'd-none', tdClass: 'd-none' },
        {key: "Name", label: this.$t("NAME") },
        { key: "editkey", label: "" },
        { key: "deletekey", label: "" }
      ],
      form: {
        Name: ""
      },
      loading: false
    };
  },
  props: ["token"],
  methods: {
    dataSuccessLoad: function(res) {
      this.classes = res;
      this.loading = false;
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }
    },
    removeClass: function(classID) {
      for (var a = 0; a < this.classes.length; a++) {
        if (this.classes[a].ID == classID) {
          this.$bvToast.toast('Class "' + this.classes[a].Name + '" was deleted!', { autoHideDelay: 5000, appendToast: true});
          this.classes.splice(a, 1);
          break;
        }
      }
    },
    createClassSuccess: function(res) {
      this.classes.push({ ID: res.insertId, Name: this.form.Name });

      this.$bvToast.toast('Class "' + this.form.Name + '" created!', { autoHideDelay: 5000, appendToast: true});

      this.form = {
        Name: ""
      };

      this.loading = false;
    },
    onSubmit: function(event) {
      event.preventDefault();
      this.loading = true;

      ajaxPost(
        apiUrl() + "/classes",
        this.form,
        this.createClassSuccess,
        this.dataError,
        this.token
      );
    }
  }
};
</script>